/*
    Copyright (c) Microsoft Corporation. All rights reserved.
    Licensed under the MIT license.
*/
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define(["require", "exports", "../FluxCommon/Actions"], function (require, exports, Actions_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var PodsActions = /** @class */ (function (_super) {
        __extends(PodsActions, _super);
        function PodsActions() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        PodsActions.getKey = function () {
            return "pods-actions";
        };
        PodsActions.prototype.initialize = function () {
            this._podsFetched = new Actions_1.Action();
            this._podsFetchedByLabel = new Actions_1.Action();
        };
        Object.defineProperty(PodsActions.prototype, "podsFetched", {
            get: function () {
                return this._podsFetched;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(PodsActions.prototype, "podsFetchedByLabel", {
            get: function () {
                return this._podsFetchedByLabel;
            },
            enumerable: true,
            configurable: true
        });
        return PodsActions;
    }(Actions_1.ActionsHubBase));
    exports.PodsActions = PodsActions;
});
